import { FC, ReactNode, useState } from "react";
import { Link } from "react-router";

import { AuthPage } from "./types";
import { RegisterPromo } from "../register";
import { AuthWrapperContext } from "./AuthWrapperContext";
import { AUTH_LINK_CLASSNAME } from "../general";

const LINK_CLASSNAME = `${AUTH_LINK_CLASSNAME} dark:text-white`;

const pageData: Record<
  AuthPage,
  {
    title: string;
    text: string;
    linkToDescriptionText: string;
    url: string;
    linkToText: string;
    hideOtherLinks?: boolean;
  }
> = {
  signin: {
    title: "Sign In",
    text: "Log in to vviinn",
    linkToDescriptionText: "Already have a vviinn account? ",
    url: "../signin",
    linkToText: "Sign in",
  },
  register: {
    title: "Register",
    text: "Register to vviinn",
    linkToDescriptionText: "Need a vviinn account? ",
    url: "../register",
    linkToText: "Register",
  },
  reset: {
    title: "Reset password",
    text: "Reset password",
    linkToDescriptionText: "Forgot your password? ",
    url: "../resetPassword",
    linkToText: "Reset password",
  },
  onboarding: {
    title: "Start Free Trial",
    text: "Start Free Trial with vviinn",
    linkToDescriptionText: "",
    url: "../onboarding",
    linkToText: "Onboarding",
    hideOtherLinks: true,
  },
  nocompany: {
    title: "Welcome to the vviinn Panel",
    text: "Welcome to the vviinn Panel",
    linkToDescriptionText: "",
    url: "../noCompany",
    linkToText: "No Company",
    hideOtherLinks: true,
  },
  invite: {
    title: "Accept Invitation",
    text: "Set up your account",
    linkToDescriptionText: "",
    url: "",
    linkToText: "",
    hideOtherLinks: true,
  },
  completeProfile: {
    title: "Complete Your Profile",
    text: "Set up your account",
    linkToDescriptionText: "",
    url: "",
    linkToText: "",
    hideOtherLinks: true,
  },
};

const createLinks = (pageType: AuthPage, hideSignInLink: boolean) => {
  const otherAuthMethods: ReactNode[] = [];
  Object.keys(pageData).forEach((key) => {
    if (key !== pageType && !(hideSignInLink && key === "signin")) {
      const typedKey = key as AuthPage;

      const { linkToDescriptionText, url, linkToText } = pageData[typedKey];

      linkToDescriptionText &&
        otherAuthMethods.push(
          <p
            className="mt-2 text-center text-sm text-stone-700 dark:text-stone-200"
            key={key}
          >
            {linkToDescriptionText}
            <Link className={LINK_CLASSNAME} to={url}>
              {linkToText}
            </Link>
          </p>,
        );
    }
  });
  return otherAuthMethods;
};

export const AuthWrapper: FC<
  React.PropsWithChildren<{ pageType: AuthPage }>
> = ({ pageType, children }) => {
  const [isSigningIn, setIsSigningIn] = useState(false);

  return (
    <>
      <title>{pageData[pageType].title}</title>

      <div className="flex min-h-full flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="max-sm:px-7 sm:mx-auto sm:w-full sm:max-w-md">
          <h2 className="text-primary text-center text-3xl font-semibold ">
            {pageData[pageType].text}
          </h2>
        </div>

        {pageType === "register" && RegisterPromo}

        <div className="flex justify-center">
          <div className="mt-8 w-4/5 sm:mx-auto sm:w-full sm:max-w-md">
            <div className="rounded-lg bg-stone-50 px-4 py-8 shadow dark:bg-stone-800 sm:px-10">
              <AuthWrapperContext.Provider value={{ setIsSigningIn }}>
                {children}
              </AuthWrapperContext.Provider>
            </div>
          </div>
        </div>

        {!pageData[pageType].hideOtherLinks && (
          <div className="mt-4 flex flex-col justify-center">
            {createLinks(pageType, pageType === "register" && isSigningIn)}
          </div>
        )}
      </div>
    </>
  );
};
